define(['mage/translate', 'jquery'], ($t, $) => {
    'use strict';

    class NewleafSliderControls {

        /** @type {Boolean} */
        buttons = true;

        /** @type {HTMLButtonElement} */
        next;

        /** @type {HTMLButtonElement} */
        prev;

        /** @type {array<string>} */
        wrapperClasses = [];

        /** @type {string|null} */
        justify = null;

        /**
         * @type {string}
         * @deprecated set --newleaf-disabled-button-background on the container
         */
        disabledButtonBackground = false;

        /** @type {Boolean} */
        centerMode = false;

        /**
         * @param {Object} config initialization config
         * @param {Element} el slider element
         */
        constructor (config, el) {
            Object.keys(config)
                .filter(key => ['buttons', 'wrapperClasses', 'justify', 'disabledButtonBackground', 'centerMode'].indexOf(key))
                .forEach(key => this[key] = config[key]);
            this.addButtons(el);
            this.listenScroll(el);
            this.updateButtonAvailability(el);
        }

        /**
         * @param {Element} slider slider element
         */
        addButtons (slider) {
            if (!this.buttons) {
                return;
            }
            const doc = slider.ownerDocument;
            const buttons = doc.createElement('div');
            const buttonWrapper = doc.createElement('div');
            buttonWrapper.classList.add('newleaf-circle-button-wrapper', ...this.wrapperClasses);
            buttonWrapper.ariaHidden = 'true';
            if (this.justify) {
                buttonWrapper.style.setProperty('--newleaf-button-justify', this.justify);
            }

            if (this.disabledButtonBackground) {
                buttonWrapper.style.setProperty('--newleaf-disabled-button-background', this.disabledButtonBackground);
            }

            this.prev = doc.createElement('button');
            this.prev.classList.add('icon-chevron-left');
            this.prev.addEventListener("click", () => this.listenButtonClick(-1, slider));

            this.next = doc.createElement('button');
            this.next.classList.add('icon-chevron-right');
            this.next.addEventListener("click", () => this.listenButtonClick(1, slider));

            buttons.appendChild(this.prev);
            buttons.appendChild(this.next);
            buttonWrapper.appendChild(buttons);
            slider.insertAdjacentElement('afterend', buttonWrapper);

            const resizeObserver = new ResizeObserver(() => {
                this.updateButtonAvailability(slider);
                const buttonsDisabled = this.prev.disabled && this.next.disabled;
                buttonWrapper.style.visibility = buttonsDisabled ? 'hidden' : 'unset';
            });

            resizeObserver.observe(slider);
        }

        /**
         * @param {number} direction scroll direction
         * @param {Element} slider slider element
         * @returns {void}
         */
        listenButtonClick (direction, slider) {
            const $el = $(slider);
            const gapWidth = parseInt(getComputedStyle(slider).gap, 10);
            const slideWidth = parseInt(getComputedStyle(slider.firstElementChild).width, 10);
            let scrollAmount = slideWidth + gapWidth;

            // when center mode is enabled and we're at the first or last slide, we need to calculate a different scroll amount
            if (this.centerMode &&
                (this.next.disabled || this.prev.disabled)) {

                const containerWidth = $el.outerWidth();
                const slideCount = Math.floor(containerWidth / slideWidth);
                const evenSlideCount = slideCount % 2 === 0;
                const sideGap = (containerWidth - $el.width()) / 2;
                const totalGapWidth = gapWidth * slideCount;
                const totalSlideWidth = slideCount * slideWidth;
                const peekWidth = containerWidth - sideGap - totalSlideWidth - totalGapWidth;
                scrollAmount = evenSlideCount ? (sideGap + slideWidth - peekWidth) / 2 : slideWidth + gapWidth - (peekWidth / 2);
            }

            slider.classList.add('no-snap');
            $el.animate({
                scrollLeft: `+=${scrollAmount * direction}`
            }, {
                duration: 450,
                easing: 'linear',
                //todo: find a means of adding a function to the *end of the queue* rather than adding multiple *end of animation* functions
                complete: () => {
                    const queue = $el.queue();
                    // the final "complete" fn is called with a queue that looks like `['inprogress']`
                    if (queue.length === 1 && queue[0] === 'inprogress') {
                        slider.classList.remove('no-snap');
                    }
                }
            });
        }

        /**
         * @param {Element} slider slider DOM el
         */
        listenScroll (slider) {
            let ticking = false;
            slider.addEventListener('scroll', e => {
                if (!ticking) {
                    requestAnimationFrame(() => {
                        this.updateButtonAvailability(slider);
                        ticking = false;
                    });
                    ticking = true;
                }
            });
        }

        /**
         * @param {Element} slider slider DOM el
         */
        updateButtonAvailability (slider) {

            if (!this.buttons) {
                return;
            }
            const denom = slider.scrollWidth - slider.clientWidth;
            const slideCount = slider.querySelectorAll('.slide').length;
            if (denom === 0) {
                this.prev.disabled = this.next.disabled = true;
                return;
            }

            this.prev.disabled = this.next.disabled = false;

            if (this.centerMode) {
                if (slider.scrollLeft === 0) {
                    this.prev.disabled = true;
                }

                if (denom === slider.scrollLeft) {
                    this.next.disabled = true;
                }

                return;
            }

            const scrollAmount = slider.scrollLeft / denom;
            if (scrollAmount <= 1 / slideCount) {
                this.prev.disabled = true;
            }

            if (scrollAmount >= (slideCount - 1) / slideCount) {
                this.next.disabled = true;
            }
        }
    }

    return (config, el) => new NewleafSliderControls(config, el);
});
